import React, { Component } from "react";
import { Input, DatePicker } from "antd";
import moment from "moment";

import { Dropdown } from "./dropdown";
import { apiConstract } from "../../api/api-constract";
import { emitter } from "../../common/utils/emitter";

const LEND = [
  { id: 0, name: "Tất cả", lend_car: null, lend_driver: null },
  { id: 1, name: "Đang cho mượn xe & tài", lend_car: true, lend_driver: true },
  { id: 2, name: "Đang cho mượn xe", lend_car: true, lend_driver: false },
  { id: 3, name: "Đang cho mượn tài", lend_car: false, lend_driver: true },
];
const INIT_CONTRACT_STATUS = [
  { id: -1, code: "ALL", name: "Tất cả" },
  {
    id: 1,
    code: "WAITING_ASSIGN_CAR",
    name: "Đang chờ điều xe",
    color: "#fbe350",
  },
  { id: 2, code: "ASSIGNED_CAR", name: "Đã điều xe", color: "#e68927" },
  { id: 3, code: "IN_PROGRESS", name: "Đang diễn ra", color: "#45acf9" },
  { id: 4, code: "FINISHED", name: "Đã hoàn thành", color: "#139123" },
  { id: 5, code: "CANCELED", name: "Đã huỷ", color: "#d11338" },
];

export class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      tax_code: "",
      address: "",
      admin_user: "",
      created_user: "",
      company_name: "",
      mobile: "",
      email: "",
      contract_code: "",
      signing_date: "",
      duration: "",
      branch: "",
      customer: "",
      status: "",
      creator: "",
      created_date: "",
      lend_car: null,
      lend_driver: null,
      branchList: [],
      car_type: "",
      driver: "",
      checkSearch: false,
    };
    //this.branchs = [];
  }

  componentWillReceiveProps(newProps) {
    if (newProps.has_driver !== this.props.has_driver) {
      this.dropdown.setState({
        title: "Trạng thái",
        titleColor: "colorTitleFirst",
      });
      this.setState({ status: null });
    }
  }

  async componentDidMount() {
    try {
      const dataBranch = await apiConstract.getBranch();
      if (dataBranch.status == "success") {
        let dataConvert = dataBranch.data.map((item) => {
          return {
            ...item,
            name: item.code,
          };
        });
        dataConvert.unshift({ id: -1, code: "all", name: "Tất cả" });
        this.setState({ branchList: dataConvert });
      } else {
        emitter.emit("FETCH_LOADING", false);
      }
    } catch (error) {
      emitter.emit("FETCH_LOADING", false);
    }
  }
  onChangeText = (feild, value) => {
    this.setState({ [feild]: value, checkSearch: false });
  };

  search = (event) => {
    if (event.keyCode === 13) {
      this.submitSearch();
      event.preventDefault();
    }
  };

  submitSearch = async () => {
    await this.setState({
      checkSearch: true,
    });
    this.props.search(1);
  };
  signingDate = (date, dateString) => {
    const unixNew = moment(dateString, "DD/MM/YYYY").unix();
    this.setState({
      signing_date: unixNew * 1000,
      checkSearch: false,
    });
  };
  createdDate = (date, dateString) => {
    const unixNew = moment(dateString, "DD/MM/YYYY").unix();
    this.setState({
      created_date: unixNew * 1000,
      checkSearch: false,
    });
  };
  setLend = (value) => {
    this.setState({
      lend_driver: value.lend_driver,
      lend_car: value.lend_car,
      checkSearch: false,
    });
  };
  setBranch = (value) => {
    if (value.id == -1) {
      this.setState({
        branch: null,
        checkSearch: false,
      });
    } else {
      this.setState({
        branch: value.name,
        checkSearch: false,
      });
    }
  };
  setStatus = (value) => {
    if (value.id == -1) {
      this.setState({
        status: null,
        checkSearch: false,
      });
    } else {
      this.setState({
        status: value.id,
        checkSearch: false,
      });
    }
  };
  handleChangeDuration = (e) => {
    const { value } = e.target;
    this.onChangeText("duration", value.replace(/\D+/g, ""));
  };

  render() {
    const {
      name,
      tax_code,
      address,
      admin_user,
      created_date,
      created_user,
      contract_code,
      duration,
      customer,
      creator,
      branchList,
      number_plate,
      driver,
      status,
    } = this.state;
    const { type, has_driver } = this.props;
    let contractStatus = INIT_CONTRACT_STATUS;
    if (has_driver) {
      contractStatus = INIT_CONTRACT_STATUS.concat([
        { id: 6, code: "CAR_LOAN", name: "Đang cho mượn xe", color: "#b330dc" },
        {
          id: 7,
          code: "DRIVER_LOAN",
          name: "Đang cho mượn tài",
          color: "#32dc8e",
        },
        {
          id: 8,
          code: "CAR_DRIVER_LOAN",
          name: "Đang cho mượn xe và tài",
          color: "#E60EBB",
        },
      ]);
    }

    if (type === "CONTRACT") {
      return (
        <div id="search" className="search-bar">
          <div className="search-container">
            <div className="search-contract">
              <Input
                onKeyDown={this.search}
                onChange={(param) =>
                  this.onChangeText("contract_code", param.target.value)
                }
                value={contract_code}
                placeholder="Mã hợp đồng"
                className="input"
              />
              <DatePicker
                // inputReadOnly
                dropdownClassName="date-picker-dropdown-bottom"
                getPopupContainer={(node) => {
                  if (node) {
                    return node.parentNode;
                  }
                  return document.body;
                }}
                className="input"
                onChange={this.signingDate}
                placeholder="Ngày ký"
                format="DD/MM/YYYY"
              />

              <Input
                onKeyDown={this.search}
                onChange={this.handleChangeDuration}
                value={duration}
                placeholder="Thời hạn"
                className="input"
              />
              <Dropdown
                select={(value) => this.setBranch(value)}
                className="input"
                menu={branchList}
                title="Chi nhánh"
              />
            </div>
            <div className="search-contract">
              <Input
                onKeyDown={this.search}
                onChange={(param) =>
                  this.onChangeText("customer", param.target.value)
                }
                value={customer}
                placeholder="Khách hàng"
                className="input"
              />
              <Dropdown
                ref={(ref) => (this.dropdown = ref)}
                select={(value) => this.setStatus(value)}
                className="input"
                menu={contractStatus}
                title="Trạng thái"
              />
              <Input
                onKeyDown={this.search}
                onChange={(param) =>
                  this.onChangeText("number_plate", param.target.value)
                }
                value={number_plate}
                placeholder="Biển KS"
                className="input"
              />
              <Input
                onKeyDown={this.search}
                onChange={(param) =>
                  this.onChangeText("driver", param.target.value)
                }
                value={driver}
                placeholder="Tài xế"
                className="input"
              />

              {/* <Input onKeyDown={this.search} onChange={param => this.onChangeText('created_date', param.target.value)} value={created_date} placeholder="Ngày tạo HĐ" className="input" /> */}
            </div>
            <div className="search-contract">
              <Input
                onKeyDown={this.search}
                onChange={(param) =>
                  this.onChangeText("creator", param.target.value)
                }
                value={creator}
                placeholder="Người tạo"
                className="input"
              />
              {/* <DatePicker
                inputReadOnly
                dropdownClassName="date-picker-dropdown-bottom"
                getPopupContainer={node => {
                  if (node) {
                    return node.parentNode;
                  }
                  return document.body;
                }}
                className="input"
                onChange={this.createdDate}
                placeholder="Ngày tạo HĐ"
                format="DD/MM/YYYY"
              />
              <div className="input"/>
              <div className="input" /> */}
            </div>
          </div>
          <div onClick={this.submitSearch} className="btn-success">
            <img
              alt=""
              onClick={this.submitSearch}
              style={{
                objectFit: "contain",
                cursor: "pointer",
                marginRight: 5,
              }}
              width={16}
              src={require("../../assets/icons/search-solid-white.png")}
            />
            Search
          </div>
        </div>
      );
    }

    return (
      <div className="search-bar">
        <div className="search-user-container">
          <div className="search-contract">
            <Input
              onKeyDown={this.search}
              onChange={(param) =>
                this.onChangeText("name", param.target.value)
              }
              value={name}
              placeholder="Tên khách hàng"
              className="input"
            />
            <Input
              onKeyDown={this.search}
              onChange={(param) =>
                this.onChangeText("tax_code", param.target.value)
              }
              value={tax_code}
              placeholder="Mã số thuế"
              className="input"
            />
            <Input
              onKeyDown={this.search}
              onChange={(param) =>
                this.onChangeText("address", param.target.value)
              }
              value={address}
              placeholder="Địa chỉ"
              className="input"
            />
          </div>
          <div className="search-contract">
            <Input
              onKeyDown={this.search}
              onChange={(param) =>
                this.onChangeText("admin_user", param.target.value)
              }
              value={admin_user}
              placeholder="Admin user"
              className="input"
            />
            <Input
              onKeyDown={this.search}
              onChange={(param) =>
                this.onChangeText("created_user", param.target.value)
              }
              value={created_user}
              placeholder="Người tạo"
              className="input"
            />
            {/* <Input onKeyDown={this.search} onChange={param => this.onChangeText('created_date', param.target.value)} value={created_date} placeholder="Ngày tạo KH" className="input" /> */}
            <DatePicker
              // inputReadOnly
              dropdownClassName="date-picker-dropdown-bottom"
              getPopupContainer={(node) => {
                if (node) {
                  return node.parentNode;
                }
                return document.body;
              }}
              className="input"
              onChange={this.createdDate}
              placeholder="Ngày tạo KH"
              format="DD/MM/YYYY"
            />
          </div>
        </div>
        <div onClick={this.submitSearch} className="btn-success">
          <img
            alt=""
            onClick={this.submitSearch}
            style={{ objectFit: "contain", cursor: "pointer", marginRight: 5 }}
            width={16}
            src={require("../../assets/icons/search-solid-white.png")}
          />
          Search
        </div>
      </div>
    );
  }
}
